export const FAMILY_DETAILS = "FAMILY_DETAILS";
export const ERROR_MSG = "ERROR_MSG";
export const SELECTED_MEMBER = "SELECTED_MEMBER";
export const STOP_FAM_API_CALL = "STOP_FAM_API_CALL";
export const CONSOLIDATED_DETAILS = "CONSOLIDATED_DETAILS";
export const SEARCH = "SEARCH";
